import {
  Directive,
  ElementRef,
  HostListener,
  forwardRef
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Directive({
  selector: '[appNegativeOnly]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NegativeOnlyDirective),
      multi: true
    }
  ]
})
export class NegativeOnlyDirective implements ControlValueAccessor {

  private onChange = (_: number | null) => {};
  private onTouched = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: number | null): void {
    if (value == null) {
      this.el.nativeElement.value = '';
      return;
    }

    // Display positive value
    this.el.nativeElement.value = Math.abs(value).toString();
  }

  registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const digits = value.replace(/[^\d]/g, '');

    // Keep display positive
    this.el.nativeElement.value = digits;

    // Emit negative value to Angular form
    this.onChange(digits ? -Number(digits) : null);
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }
}